<div *ngIf="!captchaVerified && !signupMode" style="width: 100%; display: flex; justify-content: center;">
    <re-captcha (resolved)="resolvedRecaptcha($event)" [siteKey]="siteKey"></re-captcha>
</div>
<div *ngIf="captchaVerified || signupMode">
    <h4 *ngIf="paymentStatus !== ALLSET_MESSAGE">
      {{ chosenPlan.name }} <span class="text-muted small">&mdash; {{ chosenPlan.description }}</span>
    </h4>
    <h4 *ngIf="paymentStatus !== ALLSET_MESSAGE; else thankYouMsg">
      <strong style="text-transform: lowercase;">
          {{ currencySymbol + displayOriginalAmt }} {{ chosenPlan.cadenceDisp.key }}
      </strong>
    </h4>
    <p *ngIf="chosenPlan.price === 0">
      You won't be billed unless you choose to subscribe.
      <br>
      <app-slant-button *ngIf="!collapseAnyway" [linkMode]="true" tooltip="You can enter your payment info later if you choose to subscribe." (click)="collapseAnyway = true; successfullySubscribed.emit()">
          Skip payment entry
      </app-slant-button>
    </p>
    <ng-template #thankYouMsg>
      <h4 style="text-align: center;">Thank you!</h4>
    </ng-template>
    <app-fortis-manage-payment #paymentManager [collapse]="collapseAnyway || (showPaymentStatus === true && paymentStatus === ALLSET_MESSAGE)" [isAnimated]="true" [userAccount]="userAccount" [newUserMode]="signupMode" [standaloneMode]="false" [darkMode]="darkMode" (hasValidCard)="setCardStatus($event)"></app-fortis-manage-payment>
    <form id="payment-form" [collapse]="(showPaymentStatus === true && paymentStatus === ALLSET_MESSAGE) || !cardStatus" [isAnimated]="true" [ngClass]="{'dark-mode': darkMode}">
      <!-- <h6>Please confirm payment method and agree to the terms</h6> -->
      <!-- <div id="card-container"></div> Square card form inserts here. -->
    
      <div id="purchaseBox">
          <div class="form-row mb-3" *ngIf = "!isHandset; else discountMobile">
              <label for="discountCode" style="font-size: 1em; padding-top: 5px;" class="col-3">
                  Discount code
              </label>
              <input class="form-control editable col-4" (keyup.esc)="discountCode = ''; checkDiscountCode()" (blur)="checkBlankDiscount()" (keyup.enter)="checkDiscountCode()"
              type="text" style="margin-top: 0" name="discountCode" id="discountCode" placeholder="(optional)" tabindex="0" [ngClass]="{'warning': discountCode && badCode}" [(ngModel)]="discountCode">
              <i *ngIf="discountCode && badCode === true" class="col-1 fas fa-exclamation-triangle text-warning" style="line-height: 2em;" matTooltip="That discount code is invalid" [matTooltipShowDelay]="tooltipDelay"></i>
              <i *ngIf="discountCode && badCode === false" class="col-1 fal fa-check text-success" style="line-height: 2em;" matTooltip="The discount has been applied." [matTooltipShowDelay]="tooltipDelay"></i>
              <button class="btn btn-sm btn-outline-success ms-2" [disabled]="discountCode === ''" type="button" (click)="checkDiscountCode()">
                  Apply
              </button>
          </div>

          <ng-template #discountMobile>
            <div class = "wrapper form-row mb-3">
                <label for="discountCode" style="font-size: 1em; padding-top: 5px; display: flex; justify-content: center;" class="col-12">
                    Discount code
                </label>

                <div class = "col-12" style ="display: flex; justify-content: center; padding-top: 10px;">
                    <input class="form-control editable col-8" (keyup.esc)="discountCode = ''; checkDiscountCode()" (blur)="checkBlankDiscount()" (keyup.enter)="checkDiscountCode()" type="text" style="margin-top: 0; background-color: whitesmoke;" name="discountCode" id="discountCode" placeholder="(optional)" tabindex="0" [ngClass]="{'warning': discountCode && badCode}" [(ngModel)]="discountCode">

                    <button class="btn btn-sm btn-outline-success ms-2" style="width: 50%" [disabled]="discountCode === ''" type="button" (click)="checkDiscountCode()">
                        Apply
                    </button>
                </div>

                <div class = "col-12" style ="display: flex; justify-content: center; padding-top: 10px;">

                    <i *ngIf="discountCode && badCode === true" class="col-6 fas fa-exclamation-triangle text-warning" style="line-height: 2em;" matTooltip="That discount code is invalid" [matTooltipShowDelay]="tooltipDelay"> Invalid Code
                    </i>
                
                    <i *ngIf="discountCode && badCode === false" class="col-6 fal fa-check text-success" style="line-height: 2em;" matTooltip="The discount has been applied." [matTooltipShowDelay]="tooltipDelay"> Success
                    </i>

                </div>
            </div>
          </ng-template>

          <div class="form-row mb-2">
              <div class="form-check form-check-inline">
                  <input type="checkbox" class="form-check-input col-1" style="height: 18px; width: auto; margin-top: 10px;" id="agreeToTermsChk" name="agreeToTermsChk" [(ngModel)]="agreeToTerms">
                  <label for="agreeToTermsChk" style="font-size: 1rem;" class="label">
                      {{ subscriberTermsText }}
                  </label>
              </div>
              <label *ngIf="!agreeToTerms" for="agreeToTerms" class="ms-2 form-text text-danger small">
                  You must agree to the terms to continue.
              </label>
          </div>
          <hr>
          <div class="itemizeLine row">
              <div class = "planAndSymbol" [ngClass]="{'col-10': !isHandset, 'col-8': isHandset}">
                {{ chosenPlan.name }} price: {{ currencySymbol }}
              </div>
              <div class="moneyAlign col-2" [ngClass]="{'col-2': !isHandset, 'col-4': isHandset}">
                  {{ displayOriginalAmt }}
              </div>
          </div>
          <div class="itemizeLine row">
              <div class="discountAndSymbol" [ngClass]="{'col-10': !isHandset, 'col-8': isHandset}">
                  <i *ngIf="discountCode && badCode === true" class="fas fa-exclamation-triangle text-warning me-1" matTooltip="No discount was applied because the code entered was invalid." [matTooltipShowDelay]="tooltipDelay"></i>
                  Discount: {{ currencySymbol }}
              </div>
              <div class="moneyAlign" [ngClass]="{'col-2': !isHandset, 'col-4': isHandset}">
                  {{ displayDiscountAmt }}
              </div>
          </div>  
          <div class="totalsLine row">
              <div class="totalAndSymbol" [ngClass]="{'col-10': !isHandset, 'col-8': isHandset}">
                TOTAL: {{ currencySymbol }}
            </div>
              <div class="moneyAlign" [ngClass]="{'col-2': !isHandset, 'col-4': isHandset}">
                  {{ displayPaymentAmt }}<span class="small" style="position: absolute;"><strong>*</strong></span>
              </div>
          </div>
          <button id="card-button" [disabled]="!paymentReady || !cardStatus || !agreeToTerms" type="button" (click)="handlePaymentMethodSubmission($event)">
              Subscribe {{ chosenPlan.cadenceDisp.key }}
              <i style="color: black;" class="fal fa-spinner-third fa-spin ms-1" *ngIf="paymentProcessing"></i>
          </button> <!-- <== Square payment button inserts here -->
          <span class="small" style="float: right;">
              <strong>*</strong>Excluding taxes
          </span><br>
          <span class="small">
              <i class="fal fa-sm fa-lock me-1"></i>All payments are processed securely through Fortis
          </span>
      </div>
    </form>
    <div id="payment-status-container" [hidden]="!showPaymentStatus" [ngClass]="{'missing-credentials': credentialError}">
      <!-- Dynamic content from Square form -->
    </div>
    <div class="alert alert-danger" *ngIf="credentialError">
      <i class="fal fa-exclamation-triangle me-1"></i>
      The payment form could not initialize!
    </div>
    <div class="text-center mb-2">
      {{ paymentStatus }}
    </div>
    <div *ngIf="!signupMode" id="paymentLegal" class="small text-muted text-center mb-1">
      By using this website, you agree to our <a href="../../assets/documents/Terms_and_Conditions.pdf" target="_blank" rel="noopener noreferrer">terms of service</a>.
    </div>
</div>
